import Vue from 'vue'

Vue.filter('noValue', function(value) {
    return value || value === 0 ? value : '—'
})
